/*
 * # Fomantic UI - 2.8.8
 * https://github.com/fomantic/Fomantic-UI
 * http://fomantic-ui.com/
 *
 * Copyright 2021 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
!function (E, e, T, P) {
  "use strict";

  E.isFunction = E.isFunction || function (e) {
    return "function" == typeof e && "number" != typeof e.nodeType;
  }, e = void 0 !== e && e.Math == Math ? e : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), E.fn.progress = function (m) {
    var b,
      e = E(this),
      h = e.selector || "",
      x = new Date().getTime(),
      y = [],
      w = m,
      A = "string" == typeof w,
      V = [].slice.call(arguments, 1);
    return e.each(function () {
      var c,
        s = E.isPlainObject(m) ? E.extend(!0, {}, E.fn.progress.settings, m) : E.extend({}, E.fn.progress.settings),
        n = s.className,
        t = s.metadata,
        e = s.namespace,
        r = s.selector,
        l = s.error,
        a = "." + e,
        o = "module-" + e,
        u = E(this),
        p = E(this).find(r.bar),
        i = E(this).find(r.progress),
        d = E(this).find(r.label),
        g = this,
        v = u.data(o),
        f = !1;
      c = {
        helper: {
          sum: function (e) {
            return Array.isArray(e) ? e.reduce(function (e, t) {
              return e + Number(t);
            }, 0) : 0;
          },
          derivePrecision: function (e, t) {
            for (var n = 0, r = 1, a = e / t; n < 10 && !(1 < (a *= r));) r = Math.pow(10, n++);
            return r;
          },
          forceArray: function (e) {
            return Array.isArray(e) ? e : isNaN(e) ? "string" == typeof e ? e.split(",") : [] : [e];
          }
        },
        initialize: function () {
          c.set.duration(), c.set.transitionEvent(), c.debug(g), c.read.metadata(), c.read.settings(), c.instantiate();
        },
        instantiate: function () {
          c.verbose("Storing instance of progress", c), v = c, u.data(o, c);
        },
        destroy: function () {
          c.verbose("Destroying previous progress for", u), clearInterval(v.interval), c.remove.state(), u.removeData(o), v = P;
        },
        reset: function () {
          c.remove.nextValue(), c.update.progress(0);
        },
        complete: function (e) {
          (c.percent === P || c.percent < 100) && (c.remove.progressPoll(), !0 !== e && c.set.percent(100));
        },
        read: {
          metadata: function () {
            var e = {
              percent: c.helper.forceArray(u.data(t.percent)),
              total: u.data(t.total),
              value: c.helper.forceArray(u.data(t.value))
            };
            e.total !== P && (c.debug("Total value set from metadata", e.total), c.set.total(e.total)), 0 < e.value.length && (c.debug("Current value set from metadata", e.value), c.set.value(e.value), c.set.progress(e.value)), 0 < e.percent.length && (c.debug("Current percent value set from metadata", e.percent), c.set.percent(e.percent));
          },
          settings: function () {
            !1 !== s.total && (c.debug("Current total set in settings", s.total), c.set.total(s.total)), !1 !== s.value && (c.debug("Current value set in settings", s.value), c.set.value(s.value), c.set.progress(c.value)), !1 !== s.percent && (c.debug("Current percent set in settings", s.percent), c.set.percent(s.percent));
          }
        },
        bind: {
          transitionEnd: function (t) {
            var e = c.get.transitionEnd();
            p.one(e + a, function (e) {
              clearTimeout(c.failSafeTimer), t.call(this, e);
            }), c.failSafeTimer = setTimeout(function () {
              p.triggerHandler(e);
            }, s.duration + s.failSafeDelay), c.verbose("Adding fail safe timer", c.timer);
          }
        },
        increment: function (e) {
          var t, n;
          e = c.has.total() ? (t = c.get.value(), e || 1) : (t = c.get.percent(), e || c.get.randomValue()), n = t + e, c.debug("Incrementing percentage by", t, n, e), n = c.get.normalizedValue(n), c.set.progress(n);
        },
        decrement: function (e) {
          var t, n;
          c.get.total() ? (n = (t = c.get.value()) - (e = e || 1), c.debug("Decrementing value by", e, t)) : (n = (t = c.get.percent()) - (e = e || c.get.randomValue()), c.debug("Decrementing percentage by", e, t)), n = c.get.normalizedValue(n), c.set.progress(n);
        },
        has: {
          progressPoll: function () {
            return c.progressPoll;
          },
          total: function () {
            return !1 !== c.get.total();
          }
        },
        get: {
          text: function (e, t) {
            var n = t || 0,
              r = c.get.value(n),
              a = c.get.total(),
              o = f ? c.get.displayPercent(n) : c.get.percent(n),
              i = !1 !== a ? Math.max(0, a - r) : 100 - o;
            return e = (e = e || "").replace("{value}", r).replace("{total}", a || 0).replace("{left}", i).replace("{percent}", o).replace("{bar}", s.text.bars[n] || ""), c.verbose("Adding variables to progress bar text", e), e;
          },
          normalizedValue: function (e) {
            if (e < 0) return c.debug("Value cannot decrement below 0"), 0;
            if (c.has.total()) {
              if (e > c.total) return c.debug("Value cannot increment above total", c.total), c.total;
            } else if (100 < e) return c.debug("Value cannot increment above 100 percent"), 100;
            return e;
          },
          updateInterval: function () {
            return "auto" == s.updateInterval ? s.duration : s.updateInterval;
          },
          randomValue: function () {
            return c.debug("Generating random increment percentage"), Math.floor(Math.random() * s.random.max + s.random.min);
          },
          numericValue: function (e) {
            return "string" == typeof e ? "" !== e.replace(/[^\d.]/g, "") && +e.replace(/[^\d.]/g, "") : e;
          },
          transitionEnd: function () {
            var e,
              t = T.createElement("element"),
              n = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
              };
            for (e in n) if (t.style[e] !== P) return n[e];
          },
          displayPercent: function (e) {
            var t = E(p[e]),
              n = t.width(),
              r = u.width(),
              a = parseInt(t.css("min-width"), 10) < n ? n / r * 100 : c.percent;
            return 0 < s.precision ? Math.round(a * (10 * s.precision)) / (10 * s.precision) : Math.round(a);
          },
          percent: function (e) {
            return c.percent && c.percent[e || 0] || 0;
          },
          value: function (e) {
            return c.nextValue || c.value && c.value[e || 0] || 0;
          },
          total: function () {
            return c.total !== P && c.total;
          }
        },
        create: {
          progressPoll: function () {
            c.progressPoll = setTimeout(function () {
              c.update.toNextValue(), c.remove.progressPoll();
            }, c.get.updateInterval());
          }
        },
        is: {
          complete: function () {
            return c.is.success() || c.is.warning() || c.is.error();
          },
          success: function () {
            return u.hasClass(n.success);
          },
          warning: function () {
            return u.hasClass(n.warning);
          },
          error: function () {
            return u.hasClass(n.error);
          },
          active: function () {
            return u.hasClass(n.active);
          },
          visible: function () {
            return u.is(":visible");
          }
        },
        remove: {
          progressPoll: function () {
            c.verbose("Removing progress poll timer"), c.progressPoll && (clearTimeout(c.progressPoll), delete c.progressPoll);
          },
          nextValue: function () {
            c.verbose("Removing progress value stored for next update"), delete c.nextValue;
          },
          state: function () {
            c.verbose("Removing stored state"), delete c.total, delete c.percent, delete c.value;
          },
          active: function () {
            c.verbose("Removing active state"), u.removeClass(n.active);
          },
          success: function () {
            c.verbose("Removing success state"), u.removeClass(n.success);
          },
          warning: function () {
            c.verbose("Removing warning state"), u.removeClass(n.warning);
          },
          error: function () {
            c.verbose("Removing error state"), u.removeClass(n.error);
          }
        },
        set: {
          barWidth: function (e) {
            c.debug("set bar width with ", e), e = c.helper.forceArray(e);
            var a = -1,
              o = -1,
              i = c.helper.sum(e),
              s = p.length,
              l = 1 < s,
              t = e.map(function (e, t) {
                var n = t === s - 1 && 0 === i,
                  r = E(p[t]);
                return 0 === e && l && !n ? r.css("display", "none") : (l && n && r.css("background", "transparent"), -1 == a && (a = t), o = t, r.css({
                  display: "block",
                  width: e + "%"
                })), parseFloat(e);
              });
            e.forEach(function (e, t) {
              E(p[t]).css({
                borderTopLeftRadius: t == a ? "" : 0,
                borderBottomLeftRadius: t == a ? "" : 0,
                borderTopRightRadius: t == o ? "" : 0,
                borderBottomRightRadius: t == o ? "" : 0
              });
            }), u.attr("data-percent", t);
          },
          duration: function (e) {
            e = "number" == typeof (e = e || s.duration) ? e + "ms" : e, c.verbose("Setting progress bar transition duration", e), p.css({
              "transition-duration": e
            });
          },
          percent: function (e) {
            e = c.helper.forceArray(e).map(function (e) {
              return e = "string" == typeof e ? +e.replace("%", "") : e, s.limitValues ? Math.max(0, Math.min(100, e)) : e;
            });
            var t = c.has.total(),
              n = c.helper.sum(e),
              r = 1 < e.length && t,
              a = c.helper.sum(c.helper.forceArray(c.value));
            if (r && a > c.total) c.error(l.sumExceedsTotal, a, c.total);else if (!r && 100 < n) c.error(l.tooHigh, n);else if (n < 0) c.error(l.tooLow, n);else {
              var o = 0 < s.precision ? s.precision : r ? c.helper.derivePrecision(Math.min.apply(null, c.value), c.total) : 0,
                i = e.map(function (e) {
                  return 0 < o ? Math.round(e * (10 * o)) / (10 * o) : Math.round(e);
                });
              c.percent = i, t && (c.value = e.map(function (e) {
                return 0 < o ? Math.round(e / 100 * c.total * (10 * o)) / (10 * o) : Math.round(e / 100 * c.total * 10) / 10;
              })), c.set.barWidth(e), c.set.labelInterval();
            }
            s.onChange.call(g, e, c.value, c.total);
          },
          labelInterval: function () {
            clearInterval(c.interval), c.bind.transitionEnd(function () {
              c.verbose("Bar finished animating, removing continuous label updates"), clearInterval(c.interval), f = !1, c.set.labels();
            }), f = !0, c.interval = setInterval(function () {
              E.contains(T.documentElement, g) || (clearInterval(c.interval), f = !1), c.set.labels();
            }, s.framerate);
          },
          labels: function () {
            c.verbose("Setting both bar progress and outer label text"), c.set.barLabel(), c.set.state();
          },
          label: function (e) {
            (e = e || "") && (e = c.get.text(e), c.verbose("Setting label to text", e), d.text(e));
          },
          state: function (e) {
            100 === (e = e !== P ? e : c.helper.sum(c.percent)) ? s.autoSuccess && 1 === p.length && !(c.is.warning() || c.is.error() || c.is.success()) ? (c.set.success(), c.debug("Automatically triggering success at 100%")) : (c.verbose("Reached 100% removing active state"), c.remove.active(), c.remove.progressPoll()) : 0 < e ? (c.verbose("Adjusting active progress bar label", e), c.set.active()) : (c.remove.active(), c.set.label(s.text.active));
          },
          barLabel: function (r) {
            i.map(function (e, t) {
              var n = E(t);
              r !== P ? n.text(c.get.text(r, e)) : "ratio" == s.label && c.has.total() ? (c.verbose("Adding ratio to bar label"), n.text(c.get.text(s.text.ratio, e))) : "percent" == s.label && (c.verbose("Adding percentage to bar label"), n.text(c.get.text(s.text.percent, e)));
            });
          },
          active: function (e) {
            e = e || s.text.active, c.debug("Setting active state"), s.showActivity && !c.is.active() && u.addClass(n.active), c.remove.warning(), c.remove.error(), c.remove.success(), (e = s.onLabelUpdate("active", e, c.value, c.total)) && c.set.label(e), c.bind.transitionEnd(function () {
              s.onActive.call(g, c.value, c.total);
            });
          },
          success: function (e, t) {
            e = e || s.text.success || s.text.active, c.debug("Setting success state"), u.addClass(n.success), c.remove.active(), c.remove.warning(), c.remove.error(), c.complete(t), e = s.text.success ? s.onLabelUpdate("success", e, c.value, c.total) : s.onLabelUpdate("active", e, c.value, c.total), c.set.label(e), c.bind.transitionEnd(function () {
              s.onSuccess.call(g, c.total);
            });
          },
          warning: function (e, t) {
            e = e || s.text.warning, c.debug("Setting warning state"), u.addClass(n.warning), c.remove.active(), c.remove.success(), c.remove.error(), c.complete(t), (e = s.onLabelUpdate("warning", e, c.value, c.total)) && c.set.label(e), c.bind.transitionEnd(function () {
              s.onWarning.call(g, c.value, c.total);
            });
          },
          error: function (e, t) {
            e = e || s.text.error, c.debug("Setting error state"), u.addClass(n.error), c.remove.active(), c.remove.success(), c.remove.warning(), c.complete(t), (e = s.onLabelUpdate("error", e, c.value, c.total)) && c.set.label(e), c.bind.transitionEnd(function () {
              s.onError.call(g, c.value, c.total);
            });
          },
          transitionEvent: function () {
            c.get.transitionEnd();
          },
          total: function (e) {
            c.total = e;
          },
          value: function (e) {
            c.value = c.helper.forceArray(e);
          },
          progress: function (e) {
            c.has.progressPoll() ? (c.debug("Updated within interval, setting next update to use new value", e), c.set.nextValue(e)) : (c.debug("First update in progress update interval, immediately updating", e), c.update.progress(e), c.create.progressPoll());
          },
          nextValue: function (e) {
            c.nextValue = e;
          }
        },
        update: {
          toNextValue: function () {
            var e = c.nextValue;
            e && (c.debug("Update interval complete using last updated value", e), c.update.progress(e), c.remove.nextValue());
          },
          progress: function (e) {
            var n = c.has.total();
            n && c.set.value(e);
            var t = c.helper.forceArray(e).map(function (e) {
              var t;
              return !1 === (e = c.get.numericValue(e)) && c.error(l.nonNumeric, e), e = c.get.normalizedValue(e), n ? (t = 0 < c.total ? e / c.total * 100 : 100, c.debug("Calculating percent complete from total", t)) : (t = e, c.debug("Setting value to exact percentage value", t)), t;
            });
            c.set.percent(t);
          }
        },
        setting: function (e, t) {
          if (c.debug("Changing setting", e, t), E.isPlainObject(e)) E.extend(!0, s, e);else {
            if (t === P) return s[e];
            E.isPlainObject(s[e]) ? E.extend(!0, s[e], t) : s[e] = t;
          }
        },
        internal: function (e, t) {
          if (E.isPlainObject(e)) E.extend(!0, c, e);else {
            if (t === P) return c[e];
            c[e] = t;
          }
        },
        debug: function () {
          !s.silent && s.debug && (s.performance ? c.performance.log(arguments) : (c.debug = Function.prototype.bind.call(console.info, console, s.name + ":"), c.debug.apply(console, arguments)));
        },
        verbose: function () {
          !s.silent && s.verbose && s.debug && (s.performance ? c.performance.log(arguments) : (c.verbose = Function.prototype.bind.call(console.info, console, s.name + ":"), c.verbose.apply(console, arguments)));
        },
        error: function () {
          s.silent || (c.error = Function.prototype.bind.call(console.error, console, s.name + ":"), c.error.apply(console, arguments));
        },
        performance: {
          log: function (e) {
            var t, n;
            s.performance && (n = (t = new Date().getTime()) - (x || t), x = t, y.push({
              Name: e[0],
              Arguments: [].slice.call(e, 1) || "",
              Element: g,
              "Execution Time": n
            })), clearTimeout(c.performance.timer), c.performance.timer = setTimeout(c.performance.display, 500);
          },
          display: function () {
            var e = s.name + ":",
              n = 0;
            x = !1, clearTimeout(c.performance.timer), E.each(y, function (e, t) {
              n += t["Execution Time"];
            }), e += " " + n + "ms", h && (e += " '" + h + "'"), (console.group !== P || console.table !== P) && 0 < y.length && (console.groupCollapsed(e), console.table ? console.table(y) : E.each(y, function (e, t) {
              console.log(t.Name + ": " + t["Execution Time"] + "ms");
            }), console.groupEnd()), y = [];
          }
        },
        invoke: function (r, e, t) {
          var a,
            o,
            n,
            i = v;
          return e = e || V, t = g || t, "string" == typeof r && i !== P && (r = r.split(/[\. ]/), a = r.length - 1, E.each(r, function (e, t) {
            var n = e != a ? t + r[e + 1].charAt(0).toUpperCase() + r[e + 1].slice(1) : r;
            if (E.isPlainObject(i[n]) && e != a) i = i[n];else {
              if (i[n] !== P) return o = i[n], !1;
              if (!E.isPlainObject(i[t]) || e == a) return i[t] !== P ? o = i[t] : c.error(l.method, r), !1;
              i = i[t];
            }
          })), E.isFunction(o) ? n = o.apply(t, e) : o !== P && (n = o), Array.isArray(b) ? b.push(n) : b !== P ? b = [b, n] : n !== P && (b = n), o;
        }
      }, A ? (v === P && c.initialize(), c.invoke(w)) : (v !== P && v.invoke("destroy"), c.initialize());
    }), b !== P ? b : this;
  }, E.fn.progress.settings = {
    name: "Progress",
    namespace: "progress",
    silent: !1,
    debug: !1,
    verbose: !1,
    performance: !0,
    random: {
      min: 2,
      max: 5
    },
    duration: 300,
    updateInterval: "auto",
    autoSuccess: !0,
    showActivity: !0,
    limitValues: !0,
    label: "percent",
    precision: 0,
    framerate: 1e3 / 30,
    percent: !1,
    total: !1,
    value: !1,
    failSafeDelay: 100,
    onLabelUpdate: function (e, t, n, r) {
      return t;
    },
    onChange: function (e, t, n) {},
    onSuccess: function (e) {},
    onActive: function (e, t) {},
    onError: function (e, t) {},
    onWarning: function (e, t) {},
    error: {
      method: "The method you called is not defined.",
      nonNumeric: "Progress value is non numeric",
      tooHigh: "Value specified is above 100%",
      tooLow: "Value specified is below 0%",
      sumExceedsTotal: "Sum of multple values exceed total"
    },
    regExp: {
      variable: /\{\$*[A-z0-9]+\}/g
    },
    metadata: {
      percent: "percent",
      total: "total",
      value: "value"
    },
    selector: {
      bar: "> .bar",
      label: "> .label",
      progress: ".bar > .progress"
    },
    text: {
      active: !1,
      error: !1,
      success: !1,
      warning: !1,
      percent: "{percent}%",
      ratio: "{value} of {total}",
      bars: [""]
    },
    className: {
      active: "active",
      error: "error",
      success: "success",
      warning: "warning"
    }
  };
}(jQuery, window, document);